import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Typography
} from "antd";
import dayjs from 'dayjs';
import React from "react";
const { Title } = Typography;

const PatientInformation = ({ getChildData, patientDetailsFMLA }) => {

  const dateFormat = "MM/DD/YYYY";
  const onChangeMethod = (e) => {
    callparent(e.target.value, "IsPatient");
  };
  const validatePhone = (_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Please enter a valid phone number."));
  };
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  const disableFutureDates = (current) => {
    // Can not select days after today
    return current && current > dayjs().endOf('day');
  };
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          Patient Information
        </Title>
      }
    >
      <Row gutter={[0, 0]} align={"bottom"} className="px-1 md:px-6">
        <Col>
          <Form.Item
            name="areupatient"
            label="Are you the patient?"
            rules={[{ required: true, message: "Please choose any option." }]}
          >
            <Radio.Group onChange={(e) => onChangeMethod(e)} value={patientDetailsFMLA.methodOfRelease} >
              <Space direction="vertical" className="ms-4"
              >
                <Radio value={"yes"} className="font-normal">
                  Yes
                </Radio>
                <Radio value={"no"} className="font-normal">
                  No
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Col>
        {patientDetailsFMLA.IsPatient == "no" ? (
          <Col>
            <Form.Item
              labelCol={{ xl: 13 }}
              layout="horizontal"
              className="patient-form-item"
              name="associatedpatient"
              label={<label>How are you associated with the patient?</label>}
              rules={[{ required: true, message: "Please select an option." }]}
            >
              <Select
                placeholder="Select an option"
                size="large"
                className="!w-full md:!w-[250px]"
                // style={{
                //   width: 250,
                // }}
                name="AssociatedWithPatient"
                onChange={(e) => callparent(e, "AssociatedWithPatient")}
                options={[
                  {
                    value: "1",
                    label: "Parent/Legal Guardian",
                  },
                  {
                    value: "2",
                    label: "Authorized Representative",
                  },
                  {
                    value: "3",
                    label: "Third Party (i.e. Insurance/Employer)",
                  },
                ]}
              />
            </Form.Item>
          </Col>
        ) : null}
      </Row>
      {patientDetailsFMLA.IsPatient == "yes" || patientDetailsFMLA.IsPatient == "no" ? (
        <Row gutter={[20, 0]} className="px-1 md:px-6">
          <Col xs={24} md={12}>
            <Form.Item
              label="Patient's First Name"
              name="firstname"
              onChange={(e) => callparent(e.target.value, "PFirstName")}
              required
              rules={[
                {
                  required: true,
                  max: 50,
                  message: "Please enter first name.",
                },
              ]}
            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Patient's Last Name"
              name="lastname"
              onChange={(e) => callparent(e.target.value, "PLastName")}
              required
              rules={[
                {
                  required: true,
                  max: 50,
                  message: "Please enter last name.",
                },
              ]}

            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>
          <Col xl={patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ? 6 : 8} xs={24} md={12}>
            <Form.Item
              name="dob"
              label="Date of Birth"
              required
              rules={[
                {
                  required: true,
                  message: "Please enter date of birth.",
                },
              ]}
            >
              <DatePicker
                format={dateFormat}
                disabledDate={disableFutureDates}
                style={{ minWidth: "100%" }}
                name="PDOB"
                onChange={(e) => callparent(e, "PDOB")}
              />
            </Form.Item>
          </Col>
          {patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ?
            <Col xl={patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ? 4 : 8} xs={24} md={12}>
              <Form.Item
                name="IsPatientMinor"
                label="Is the patient a minor?"
                rules={[{ required: true, message: "Please choose any option." }]}
              >

                <Radio.Group onChange={(e) => callparent(e.target.value, "IsPatientMinor")} value={patientDetailsFMLA.IsPatientMinor}>
                  <Radio value={"yes"} className="font-normal">
                    Yes
                  </Radio>
                  <Radio value={"no"} className="font-normal">
                    No
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            : null}
          <Col xl={patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ? 8 : 8} xs={24} md={12}>
            <Form.Item
              label="Email"
              name="email"
              onChange={(e) => callparent(e.target.value, "PEmail")}
              required
              rules={[
                { required: true, max: 100, message: "Please enter email." },
                {
                  type: "email",
                  message: "Please enter valid email.",
                },
              ]}
            >
              <Input maxLength={100} />
            </Form.Item>
          </Col>

          <Col xl={patientDetailsFMLA.IsPatient == "no" && patientDetailsFMLA.AssociatedWithPatient == 1 ? 6 : 8} xs={24} md={12}>
            <Form.Item
              className="font-medium"
              label="Phone Number"
              required
              name="phone"
              onChange={(e) =>
                callparent(e.target.value, "PatientPhoneNumber")
              }
              rules={[
                { required: true, max: 20, message: "Please enter phone number." },
                { validator: validatePhone },
              ]}
            >
              <Input maxLength={20} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Address Line 1"
              name="address1"
              onChange={(e) => callparent(e.target.value, "PAddLine1")}
              rules={[
                { required: true, max: 150, message: "Please enter address." },
              ]}
            >
              <Input maxLength={150} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Address Line 2"
              name="address2"
              onChange={(e) => callparent(e.target.value, "PAddLine2")}
            >
              <Input maxLength={150} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="City"
              name="city"
              onChange={(e) => callparent(e.target.value, "PCity")}
              required
              rules={[
                {
                  required: true,
                  max: 50,
                  message: "Please enter city name.",
                },
              ]}
            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="State"
              name="state"
              onChange={(e) => callparent(e.target.value, "PState")}
              required
              rules={[
                {
                  required: true,
                  max: 50,
                  message: "Please enter state name.",
                },
              ]}
            >
              <Input maxLength={50} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Zip Code"
              name="zipcode"
              onChange={(e) => callparent(e.target.value, "PZipCode")}
              required
              rules={[
                {
                  max: 8,
                  required: true,
                  message: "Please enter ZIP code.",
                },
                {
                  pattern: /^[0-9]+$/, // Ensure only numeric characters
                  message: "ZIP code must be numeric.",
                },
                {
                  min: 5, // Minimum length of 5 characters
                  message: "ZIP code must be at least 5 digits long.",
                },
              ]}
            // rules={[
            //   {
            //     type: 'number',
            //     message: 'Please enter the zip code' ,
            //   },
            //   {
            //     min: 5,
            //     type: 'number',
            //     message: 'Zip code must be at least 5'
            //   },
            //   {
            //     pattern: /^\d{5}(-\d{4})?$/, // US ZIP Code pattern
            //     message: 'Please enter a valid code (e.g., 12345 or 12345-6789)'
            //   },
            //   // {
            //   //   validator: (_, value) => {
            //   //     if (isNaN(value)) {
            //   //       return Promise.reject('Zip code must be a number');
            //   //     }
            //   //     return Promise.resolve();
            //   //   },
            //   // }
            // ]}
            >
              <Input maxLength={8} />
            </Form.Item>
          </Col>
        </Row>
      ) : null}
    </Card>
  );
};

export default PatientInformation;
